import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/allocation/completion/completionInput/styles.scss';export default {
  "completionInput": "_completionInput_1rrm6_1",
  "edition": "_edition_1rrm6_7",
  "input": "_input_1rrm6_11",
  "text": "_text_1rrm6_31"
};